const defaultResolution = {
  width: 0,
  height: 0,
};

const getMinimumResolutionOfCropSettings = cropSettings => (cropSettings ? cropSettings.reduce((sizes, setting) => ({
  width: (setting.width > sizes.width ? setting.width : sizes.width),
  height: (setting.height > sizes.height ? setting.height : sizes.height),
}), defaultResolution) : defaultResolution);

export default getMinimumResolutionOfCropSettings;
